import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

/**
 * Show a progress bar with the given max points and point score
 * Beside from showing a static point score, the component also enables 
 * automatic count down of the (bonus) score over a given count down time.   
 */
@Component({
    selector: 'quiz-progress',
    templateUrl: './quiz-progress.component.html',
    styleUrls: ['./quiz-progress.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class QuizProgressComponent implements OnInit {
    @Input() animateFromZero: boolean = false;
    /**
     * Initial point score to be shown in progress bar as a percentage of pointMax 
     */
    public pointScore: number = 0;
    @Input('pointScore') set delayScore(score) {
        if(!this.animateFromZero) {
            this.pointScore = score;
            return;
        }
        // Animate from zero (looks way cooler)
        this.pointScore = 0;
        // Delay point score 100 ms to show animation
        setTimeout(() => {
            this.pointScore = score;
        }, 3000)
    }

    /**
     * The maximum number of points that the progress bar can show (100%)
     */
    @Input() pointMax: number = 0;

    /**
     * Label shown to user in the progress bar before the score
     */
    @Input() label: string = '';

    /**
     * Enable special bonus count down mode, where the pointScore is decreased over a specified number of seconds
     * Point score will be counted down 1 every x bonusCountDownTime (in ms)
     */
    @Input() bonusCountDownTime: number = 0;

    /**
     * Pause count down timer
     */
    @Input() pauseBonusCountDown: boolean = false;

    /**
     * Emit when/if bonus count down timer have decreased point score to 0
     */
    @Output() countDownDone = new EventEmitter<number>();

    /**
     * Emit the current point score each bonusCountDownTime ms
     */
    @Output() pointScoreChange = new EventEmitter<number>();

    private countDownInterval: any = null;

    constructor(private cd: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        // Start bonus count down timer if this mode is enabled
        if(this.bonusCountDownTime > 0) this.startCountDown();
    }

    private startCountDown() {
        // Start count down interval
        this.countDownInterval = setInterval(() => {
            // Check if animation is done
            if(this.pointScore <= 0) {
                this.clearCountDownInterval();
                // Close this component
                this.countDownDone.emit();
                return;
            }
            // Decrease (bonus) point score
            if(!this.pauseBonusCountDown) this.pointScore--;
            // Emit the score to the world
            this.pointScoreChange.emit(this.pointScore);
            // Mark for check, as change detection does not handle setInterval as an event without apparently 
            // (and will not update the view if the component is placed inside another component without it)
            this.cd.markForCheck();
        }, this.bonusCountDownTime);
    }

    private clearCountDownInterval() {
        if(!this.countDownInterval) return;
        clearInterval(this.countDownInterval);
    }

    ngOnDestroy() {
        this.clearCountDownInterval();
    }
}
